import React, { useState, useEffect, useCallback } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { Menu, Icon, Button, Header, Modal } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  ContainerInputSearch,
  Input,
  CreateButton,
  SemanticTable,
  SemanticButton,
} from "./styles";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";

import { isAuthAdmin } from "../../../../services/auth";
import { systemLogs } from "../../../../services/system_logs";

const PresenciaisTreinamentos = (props) => {
  const [treinamentos, setTreinamentos] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTreinamentos();
  }, []);

  const loadTreinamentos = async () => {
    try {
      const treinamentos = (
        await api.get("/admin/treinamento/presencial/simple-list")
      )?.data;

      await systemLogs(
        "presencial/treinamento",
        "listou os treinamentos presenciais"
      );

      setTreinamentos(treinamentos);
      setLoading(false);
    } catch (err) {
      swal("Ocorreu um erro nos treinamentos", err, "error");
      setLoading(false);
    }
  };

  const updateStatus = useCallback(
    async (id, checked, index) => {
      try {
        const newStatus = checked == true ? "S" : "N";

        await api
          .put(`/admin/treinamento/presencial?ativo=${newStatus}&id=${id}`)
          .then(async (res) => {});

        await systemLogs(
          "presencial/treinamento",
          `editou o status treinamento de id=${id}`
        );

        const newTreinamentos = treinamentos;
        newTreinamentos[index]["ativo"] = newStatus;
        setTreinamentos([...newTreinamentos]);
      } catch (err) {
        swal("Ocorreu ao mudar o status do treinamento", err, "error");
      }
    },
    [treinamentos]
  );

  return (
    <>
      <Container>
        <AdminMenu />

        <Content>
          <Title>Controle de treinametos presenciais</Title>

          <ContainerInputSearch className="ui fluid left icon input">
            <Input
              type="search"
              placeholder="Procurar colunista..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <Icon name="search icon" />
          </ContainerInputSearch>

          <SemanticTable size="big" celled>
            <SemanticTable.Header>
              <SemanticTable.Row>
                <SemanticTable.HeaderCell>Id</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Nome</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Status</SemanticTable.HeaderCell>
              </SemanticTable.Row>
            </SemanticTable.Header>

            <SemanticTable.Body>
              {treinamentos
                .filter((treinamento) =>
                  treinamento.nome.toLowerCase().includes(search.toLowerCase())
                )
                .map((treinamento, index) => (
                  <SemanticTable.Row>
                    <SemanticTable.Cell>{treinamento.id}</SemanticTable.Cell>
                    <SemanticTable.Cell>{treinamento.nome}</SemanticTable.Cell>
                    <SemanticTable.Cell>
                      <input
                        type="checkbox"
                        checked={treinamento.ativo == "S" ? true : false}
                        onClick={(e) =>
                          updateStatus(treinamento.id, e.target.checked, index)
                        }
                      />
                      Ativo
                    </SemanticTable.Cell>
                  </SemanticTable.Row>
                ))}
            </SemanticTable.Body>
          </SemanticTable>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(PresenciaisTreinamentos);
